import { render, staticRenderFns } from "./ImportSuspect.vue?vue&type=template&id=14e7b6ba&"
import script from "./ImportSuspect.vue?vue&type=script&lang=js&"
export * from "./ImportSuspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports